// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1x7Gq","expireSoon":"styles_expireSoon__1XD0y"};